export default "__VITE_ASSET__Cr2brSs1__"